import { createContext, useContext } from 'react'
import {
  BrandWizardVisualAnalysisContextValue,
  BrandWizardVisualAnalysisProviderProps,
} from './BrandWizardVisualAnalysisContextTypes'

const BrandWizardVisualAnalysisContext = createContext<BrandWizardVisualAnalysisContextValue>({
  onChange: () => {},
  result: {
    colors: [],
    font_pairings: [],
    logo: '',
  },
})

const BrandWizardVisualAnalysisContextProvider = BrandWizardVisualAnalysisContext.Provider

export const BrandWizardVisualAnalysisProvider = ({
  children,
  onChange,
  result,
}: BrandWizardVisualAnalysisProviderProps) => {
  return (
    <BrandWizardVisualAnalysisContextProvider value={{ onChange, result }}>
      {children}
    </BrandWizardVisualAnalysisContextProvider>
  )
}

export const useBrandWizardVisualAnalysisContext = () => {
  return useContext(BrandWizardVisualAnalysisContext)
}
